// extracted by mini-css-extract-plugin
module.exports = {"textBlockClass":"page-index_textBlockClass__dZHSx"};